module.exports = __webpack_public_path__ + "img/smart-move.726cb65e.svg";